import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import mutations from './mutations';
import actions from './actions';
import state from './state';

import pcx from "./pcx/pcx";
import aisudu from "./aisudu/aisudu";
import statistics from './statistics/statistics'
import saas from "./saas";

const store = new Vuex.Store({
  state, //状态管理
  mutations, //修改state
  actions, //异步操作
  modules: { pcx, aisudu, statistics, saas } //模块
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js